import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const createAppointmentRoutes = {
  name: 'create-appointment',
  path: 'book-appointment/create',
  component: () => import('./CreateAppointment.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
